<template>
<div class="chapter">
<div class="inner_page">
<section class="div_autre" epub:type="preamble">
<div class="pre" id="pre-002"><span epub:type="pagebreak" id="page_XI" title="XI">
<h1 class="pre_tit" epub:type="title"><span>Abbreviations</span></h1>
<div class="dev">
<div class="tableau" id="tableau-001">
<div class="table-align">
<table style="border-collapse:collapse; border-spacing:0px;">
<colgroup style="padding:4px;">
<col style="width:15%;"/>
<col style="padding:4px;"/>
</colgroup>
<tbody>
<tr style="padding:4px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>AAE</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Arabian Archaeology and Epigraphy</i></p></td>
</tr>
<tr style="padding:4px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>AHPA</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Arabic History of the Patriarchs of Alexandria</i></p></td>
</tr>
<tr style="padding:4px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>BSOAS </i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Bulletin of the School of Oriental and African Studies</i></p></td>
</tr>
<tr style="padding:4px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>CCDATJ</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Christian Community Development Association<br/>
                    Theological Journal</i></p></td>
</tr>
<tr style="padding:4px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">CSCO</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Corpus Scriptorum Christianorum Orientalium</p></td>
</tr>
<tr style="padding:4px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>DOP </i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Dumbarton Oaks Papers</i></p></td>
</tr>
<tr style="padding:4px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>JA</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Journal Asiatique</i></p></td>
</tr>
<tr style="padding:4px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>JAOS</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Journal of the American Oriental Society</i></p></td>
</tr>
<tr style="padding:4px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>JCSSS</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Journal of the Canadian Society for Syriac Studies</i></p></td>
</tr>
<tr style="padding:4px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>JECS </i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Journal of Early Christian Studies</i></p></td>
</tr>
<tr style="padding:4px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>JRA</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Journal of Religion in Africa</i></p></td>
</tr>
<tr style="padding:4px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>JSP</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Journal for the Study of the Pseudepigrapha</i></p></td>
</tr>
<tr style="padding:4px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>JSS </i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Journal of Semitic Studies</i></p></td>
</tr>
<tr style="padding:4px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>JTS</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Journal of Theological Studies</i></p></td>
</tr>
<tr style="padding:4px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>ME </i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Medieval Encounters</i></p></td>
</tr>
<tr style="padding:4px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">NPNF</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">A Select Library of the Nicene and Post-Nicene Fathers of the Church. Edited by Phillip Schaff et al. 14 vols. Buffalo, NY: Christian Literature, 1819–1893.</p></td>
</tr>
<tr style="padding:4px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>OC</i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Oriens Christianus</i></p></td>
</tr>
<tr style="padding:4px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">PG</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Patrologia cursus completus. Series Graeca. Edited by J. P. Migne. 166 vols. Paris: Migne, 1857–1886.</p></td>
</tr>
<tr style="padding:4px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">PO</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Patrologia Orientalis. Edited by René Graffin et al. 41 vols. Paris, 1894–1984.</p></td>
</tr>
<tr style="padding:4px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>ROC </i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Revue de l’Orient Chrétien</i></p></td>
</tr>
<tr style="padding:4px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">STAC</p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea">Studien und Texte zu Antike und Christentum</p></td>
</tr>
<tr style="padding:4px;vertical-align:top;">
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>StPatr </i></p></td>
<td style="padding:4px;vertical-align:top;"><p class="txt_courant_ssalinea"><i>Studia Patristica </i><span epub:type="pagebreak" id="page_XII" title="XII"></span></p></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre3.vue?dbc6e9ac